import { SignIn as AWSSignIn } from 'aws-amplify-react';
import React from 'react';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import AppLogo from 'components/theme/app-logo';
import { Typography } from '@material-ui/core';

import { LINK_SIGNUP } from 'app-constants';

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    height: '100vh'
  },
  main: {
    maxWidth: 400,
    marginTop: -100
  },
  title: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  actionContainer: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit
  },
  actionLink: {
    marginLeft: theme.spacing.unit
  },
  forgotPwd: {
    textAlign: 'left',
    marginBottom: theme.spacing.unit
  }
});

class SignIn extends AWSSignIn {
  showComponent() {
    const { classes } = this.props;

    return (
      <>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="center"
          className={classes.root}
        >
          <Grid item xs={10} sm={5} className={classes.main}>
            <AppLogo size="large" />
            <Typography
              variant="h6"
              headlineMapping={{ h6: 'h1' }}
              className={classes.title}
            >
              Account Login
            </Typography>
            <TextField
              required
              label="Username"
              key="username"
              name="username"
              placeholder="Enter username"
              margin="normal"
              onChange={this.handleInputChange}
              autoComplete="new-username"
              fullWidth
              variant="outlined"
            />
            <TextField
              required
              label="Password"
              key="password"
              name="password"
              placeholder="Enter password"
              autoComplete="new-password"
              type="password"
              margin="normal"
              onChange={this.handleInputChange}
              fullWidth
              variant="outlined"
            />

            <Typography variant="body2" className={classes.forgotPwd}>
              Forgot your password?
              <Link
                component="button"
                className={classes.actionLink}
                variant="body2"
                onClick={() => this.changeState('forgotPassword')}
                data-testid="forgot-password"
              >
                Reset password
              </Link>
            </Typography>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={this.signIn}
              disabled={this.state.loading}
              className={classes.actionContainer}
            >
              Sign In
            </Button>

            <Typography variant="body2" className={classes.actionContainer}>
              No account?
              <Link
                className={classes.actionLink}
                variant="body2"
                href={LINK_SIGNUP}
                data-testid="create-account"
              >
                Create account
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SignIn);
